export default {
  Home: '/',
  Register: '/register',
  Login: '/login',
  Contacts: '/contacts',
};
